import { MouseEventHandler } from "react";
import { Link } from "react-router-dom";

import { Spinner } from "./spinner";

export function Button({
  type = "button",
  severity = "primary",
  link = false,
  text = false,
  size = "md",
  children,
  disabled,
  route,
  href,
  target,
  onClick,
  title,
  className,
  loading = false,
}: {
  type?: "submit" | "button";
  severity?: "primary" | "secondary" | "danger";
  link?: boolean;
  text?: boolean;
  size?: "sm" | "md" | "lg";
  children: React.ReactNode;
  disabled?: boolean;
  route?: string;
  href?: string;
  target?: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  title?: string;
  className?: string;
  loading?: boolean;
}) {
  const isDisabled = disabled || loading;
  const backgroundClass =
    link || text
      ? "bg-transparent"
      : severity === "secondary"
        ? "bg-gray-500"
        : severity === "danger"
          ? "bg-red-500"
          : "bg-blue-500";
  const textClass =
    (link ? "text-blue-500" : text ? "text-black" : "text-white uppercase") +
    " " +
    (size === "sm" ? "text-xs" : size === "md" ? "text-sm" : "text-base");
  const paddingClass =
    link || text
      ? ""
      : size === "sm"
        ? "px-2 py-1"
        : size === "md"
          ? "px-4 py-2"
          : "px-6 py-3";

  if (route) {
    return (
      <Link
        className={`${paddingClass} ${backgroundClass} ${textClass} ${isDisabled ? "opacity-50 cursor-not-allowed" : ""} inline-block relative cursor-pointer rounded-xs ${className ?? ""}`}
        title={title}
        to={route}
      >
        <ButtonContent loading={loading}>{children}</ButtonContent>
      </Link>
    );
  }
  if (href) {
    return (
      <a
        className={`${paddingClass} ${backgroundClass} ${textClass} ${isDisabled ? "opacity-50 cursor-not-allowed" : ""} inline-block relative cursor-pointer rounded-xs ${className ?? ""}`}
        href={href}
        target={target}
        title={title}
      >
        <ButtonContent loading={loading}>{children}</ButtonContent>
      </a>
    );
  }

  return (
    <button
      className={`${paddingClass} ${backgroundClass} ${textClass} relative cursor-pointer rounded-xs disabled:opacity-50 disabled:cursor-not-allowed ${className ?? ""}`}
      disabled={isDisabled}
      title={title}
      type={type}
      onClick={onClick}
    >
      <ButtonContent loading={loading}>{children}</ButtonContent>
    </button>
  );
}

function ButtonContent({
  loading,
  children,
}: {
  loading?: boolean;
  children: React.ReactNode;
}) {
  return (
    <>
      <div className="absolute top-0 left-0 w-full h-full flex justify-center items-center">
        {loading && <Spinner />}
      </div>
      <div className={loading ? "opacity-0" : ""}>{children}</div>
    </>
  );
}
